import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PreferenceService } from '../../shared/services/preference.service';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss'],
  imports: [AsyncPipe],
})
export class RulesComponent {
  private prefs = inject(PreferenceService);
  familyRules = this.prefs.hasFamilyRules;

  constructor() {}
}
